import styles from "./Spinner.module.scss";

export const Spinner = () => {
  return <span className={styles.spinner}></span>;
};
